import { render, staticRenderFns } from "./imgDetail.vue?vue&type=template&id=7610ccc7&scoped=true&"
import script from "./imgDetail.vue?vue&type=script&lang=js&"
export * from "./imgDetail.vue?vue&type=script&lang=js&"
import style0 from "./imgDetail.vue?vue&type=style&index=0&id=7610ccc7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7610ccc7",
  null
  
)

export default component.exports